<template>
  <div>
    <div style='text-align: center;'>
        <!-- insert your custom barcode setting your data in the GET parameter "data" -->
        <img alt='Barcode Generator TEC-IT'
            :src="'https://barcode.tec-it.com/barcode.ashx?data='+code+'&code=QRCode&imagetype=Png&eclevel=L&modulewidth=15'" class="w-100"/>
      </div>
      <div>
        <!-- back-linking to www.tec-it.com is required -->
        <a href='https://www.tec-it.com' title='Barcode Software by TEC-IT' target='_blank'>
          TEC-IT Barcode Generator
        </a>
      </div>
  </div>
</template>

<script>
    export default {
      props:{
        code: {
                type: [String],
                default: '',
                required: true
            },
      },
      data() {
        return {
          
        }
      },
      created(){
      },
      methods: {
        
      }
    }
</script>
<style scoped>
a{
  display: none;
}
</style>
